/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState } from "react";
import cx from "clsx";
import styles from "./styles.module.scss";
import { Textarea } from "../../shared/Textarea/Textarea";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import { stringUtil } from "../../utilities/string";
import { EyeIcon } from "../../assets/Icons/EyeIcon";
import { PencilBoxIcon } from "../../assets/Icons/PencilBoxIcon";

/**
 * @param {{
 *  value: string;
 *  onChange?: (value: string) => void;
 *  renderEditMode?: () => React.ReactNode;
 *  renderPreviewMode?: () => React.ReactNode;
 *  previewDangerousHTML?: boolean;
 *  previewClassName?: string;
 *  toggleOnPreviewClick?: boolean;
 *  className?: string;
 * }} param0
 */
export const TextModeToggle = ({
  value,
  onChange,
  renderEditMode,
  renderPreviewMode,
  previewDangerousHTML,
  previewClassName,
  toggleOnPreviewClick,
  className,
}) => {
  const { tCommon: t } = useAppTranslation.Common({
    keyPrefix: "textModeToggle",
  });

  const { 0: isEditMode, 1: setIsEditMode } = useState(false);

  const renderEditMode_ = () =>
    renderEditMode?.() || (
      <Textarea value={value} onChange={(e) => onChange(e.target.value)} />
    );

  const handlePreviewClick = () => {
    if (toggleOnPreviewClick) {
      setIsEditMode(true);
    }
  };

  const renderPreviewMode_ = () => (
    <div
      className={cx(styles.preview, previewClassName)}
      onClick={handlePreviewClick}
    >
      {renderPreviewMode?.() ||
        (previewDangerousHTML ? (
          <div
            dangerouslySetInnerHTML={{
              __html: stringUtil.prepareDangerousHTML(value),
            }}
          />
        ) : (
          value
        ))}
    </div>
  );

  return (
    <div className={cx(styles.root, className)}>
      <button
        type="button"
        className={styles.toggle}
        onClick={(e) => {
          e.preventDefault();
          setIsEditMode(!isEditMode);
        }}
      >
        {isEditMode ? <EyeIcon width="15px" /> : <PencilBoxIcon width="14px" />}
        {isEditMode ? t("toggle.preview") : t("toggle.edit")}
      </button>
      {isEditMode ? renderEditMode_() : renderPreviewMode_()}
    </div>
  );
};
